/* The pickers are laid out by fieldRow in FormStyles. The margin under the select keeps them apart when they stack. */
.picker {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-weight: 600;
}

.picker select {
  min-width: 0;
  margin-bottom: 1rem;
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: #ffffff;
  color: var(--color-text);
  font: inherit;
  font-weight: 400;
}

.range {
  padding: 1rem;
  border-radius: 12px;
  background: var(--color-tertiary-background);
}

/* The journey line: one dot per survey in the range, first and last a little larger. */
.journey {
  display: block;
  width: 100%;
  max-height: 2rem;
}

.journey line {
  stroke: var(--color-primary);
  stroke-width: 2;
}

.journey circle {
  fill: var(--color-primary);
}

.journey circle:first-of-type,
.journey circle:last-of-type {
  fill: var(--color-cta);
}

.rangeSummary {
  margin: 0.5rem 0 0.25rem;
  font-weight: 600;
}

.groupsHelp {
  margin: 0.5rem 0 0;
  color: var(--color-text-muted);
  font-size: 0.875rem;
}
